/* unplugin-vue-components disabled */import { render } from "./DeviceCode.vue?vue&type=template&id=4961636a&scoped=true"
import script from "./DeviceCode.vue?vue&type=script&lang=js"
export * from "./DeviceCode.vue?vue&type=script&lang=js"

import "./DeviceCode.vue?vue&type=style&index=0&id=4961636a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4961636a"]])

export default __exports__